<template>
    <div class="my_page">
        <!--SP用ヘッダー-->
        <div class="sp">
            <div class="menu">
                <div class="logo">
                    <router-link to="/"><img src="../assets/images/logo.svg" alt="logo" style="width:100%"></router-link>
                </div>
                <div class="sukikamo_list_sp">
                    <router-link to="/mypage"><img src="../assets/images/list_msg_sp.svg" alt="すきカモリスト"></router-link>
                    <div class="buttons">
                        <LoginButton/>
                    </div>
                </div>
            </div>
        </div>

        <!--PC用ホームボタン,戻るボタン-->
        <HomeBackButton/>
        <div class="pc">
            <div class="myhome_btn" :class="{hidden: sukikamo_btn_is_hidden}">
                <!--<img v-if="hoverFlag" class="myhome_fukidashi" src="../assets/images/link_myhome_fukidashi.svg" alt="すきカモ吹き出し">-->
                <router-link to="/mypage/planboard" class="myhome_sukikamo pc" v-on:mouseover="mouseOverAction" v-on:mouseleave="mouseLeaveAction"><img src="../assets/images/link_myhome_btn.svg" alt="マイホームできたカモ"></router-link>
            </div>
        </div>

        <!--すきカモリスト表示-->
        <div class="my_page_main">
            <!--タイトル-->
            <h2><img src="../assets/images/sukikamolist_tittle.svg" alt="すきカモリスト"></h2>
            <!--リストネーム-->
            <h3 class="list_name">{{selected_list_name}}</h3>
            <!--すきカモリスト一覧-->
            <div>
                <RoomCardListSukikamo :sukikamo_items="list_items" :list_id="selected_list_id"/>
            </div>
        </div>

        <!--SP用フッター-->
        <div class="sp">
            <div class="myhome_btnBox">
                <div class="footer_box" :class="{hidden: sukikamo_btn_is_hidden}">
                    <div class="myhome_btn_sp"><router-link to="/mypage/planboard"><img src="../assets/images/myhome_btn_sp.svg" alt="マイホームできたカモ"></router-link></div>
                    <div id="kamo_fukidashi"><img src="../assets/images/sukikamo_list_fukidashi_sp.svg" alt="吹き出し"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import Util from '../assets/js/Util'
    import RoomCardListSukikamo from '../components/RoomCardListSukikamo'
    import LoginButton from '../components/LoginButton'
    import HomeBackButton from '../components/HomeBackButton'

    export default {
        name: "MyPageList",
        components: { RoomCardListSukikamo,LoginButton, HomeBackButton },
        data: () => ({
            logged_in: false,
            hoverFlag: false,
            sukikamo_btn_is_hidden: false,
            callback: () => {}
        }),
        async created() {
            if ( !this.sukikamo_list ) await this.reloadSukikamoList();
            const id_param = this.$route.params.id;
            if ( !id_param ) return;
            const list = this.sukikamo_list[id_param];
            if ( !list ) return this.$router.push('/404');
        },
        computed: {
            ...mapState(["user_data", "is_sp"]),
            ...mapState('my_page', ["sukikamo_list"]),
            selected_list_id: _this => {
                const id_param = _this.$route.params.id;
                if ( !_this.sukikamo_list || !id_param ) return null;

                const list = _this.sukikamo_list[id_param];
                if ( !list ) return null;
                else return id_param;
            },
            selected_list_name: _this => {
                if (_this.selected_list_id) return _this.sukikamo_list[_this.selected_list_id].name;
                else return 'すべてのすきカモ';
            },
            list_items: _this => {
                if ( !_this.sukikamo_list ) return [];
                if ( _this.selected_list_id ) {
                    const list = _this.sukikamo_list[_this.selected_list_id];
                    return list.items || [];
                }  else {
                    let arr = [];
                    Object.keys(_this.sukikamo_list).forEach(key => {
                        arr = [...arr, ..._this.sukikamo_list[key].items];
                    });
                    return arr;
                }
            }
        },
        methods: {
            ...mapActions('my_page', ["reloadSukikamoList"]),
            mouseOverAction(){
                this.hoverFlag = true
            },
            mouseLeaveAction(){
                this.hoverFlag = false
            }
        },
        mounted(){
            // 指を離したら
            var kamo_fukidashi = document.querySelector("#kamo_fukidashi");
            window.addEventListener("touchend", function (event) {
                var fn = function() {
                    // console.log("指離し");
                    kamo_fukidashi.style.display = "block" ;
                };
                var tm = 4000;
                setTimeout(fn,tm);
            });
            //タッチしたら
            window.addEventListener("touchstart", function (event) {
                // console.log("タッチ中");
                kamo_fukidashi.style.display = "none" ;
            });

            const app = document.getElementById('app');
            const sukikamo_btn_pc = this.$el.querySelector('.pc .myhome_sukikamo');
            const sukikamo_btn_sp = this.$el.querySelector('.sp .footer_box');
            this.callback = () => this.sukikamo_btn_is_hidden = !Util.detectCollision(app, this.is_sp ? sukikamo_btn_sp : sukikamo_btn_pc);
            window.addEventListener('scroll', this.callback);
        },
        destroyed() {
            window.removeEventListener('scroll', this.callback);
        },    }
</script>

<style scoped lang="scss">
    .my_page {
        padding-bottom: 300px;
        /*すきカモリスト一覧*/
        .my_page_main {
            position: relative;
            max-width: 1074px;
            margin: 0 auto;
            /*タイトル*/
            h2 {
                text-align: center;
                margin-top: 60px;
                img {
                    padding: 60px 0 30px;
                }
            }
            /*選択フォルダ名*/
            h3 {
                text-align: center;
                margin-bottom: 57px;
                color: #816e66;
            }
        }

        /*ホームボタン、戻るボタン*/
        .homebtn {
            /*top: 0;*/
            top: 100px;
        }
        .back_btn {
            top: 150px;
        }
        .homebtn,
        .back_btn {
            /*position: absolute;*/
            position: fixed;
            left: 13%;
            @media screen and (max-width: 1800px) {
                left: 10%;
            }
            @media screen and (max-width: 1700px) {
                left: 7%;
            }
            @media screen and (max-width: 1600px) {
                left: 4%;
            }
            z-index: 50;
        }

        /*マイホームできたカモボタン*/
        .myhome_btn {
            position: relative;
            transition: 0.3s ease;
            &.hidden{
                opacity: 0;
                visibility: hidden;
            }

            .myhome_sukikamo {
                position: fixed;
                bottom: 50px;
                z-index: 50;
                right: 13%;
                @media screen and (max-width: 1800px) {
                    right: 10%;
                }
                @media screen and (max-width: 1700px) {
                    right: 7%;
                }
                @media screen and (max-width: 1600px) {
                    right: 4%;
                }
            }
        }
    }

    @media screen and (max-width:639px) {
        /*ページ全体*/
        .my_page {
            width: 100%;
            padding: 2px 10px 200px;
            box-sizing: border-box;
            box-shadow: initial;
            /*SP用ヘッダー*/
            .menu {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                max-width: 100%;
                min-width: 100%;
                position: fixed;
                background: white;
                margin-top: -2px;
                z-index: 20;

                .logo {
                    width: 95px;
                }

                /*すきカモリストボタン*/
                .sukikamo_list_sp {
                    display: flex;

                    img {
                        vertical-align: middle;
                        margin-right: 5px;
                    }
                }

                /*ログインボタン*/
                .buttons {
                    position: relative;
                    display: flex;
                    margin-right: 20px;
                }
            }

            /*SP用フッター*/
            .myhome_btnBox {
                position: relative;

                .footer_box {
                    display: flex;
                    width: 100%;
                    height: 65px;
                    padding: 10px 10px 10px 0;
                    box-sizing: border-box;
                    position: fixed;
                    bottom: 0;
                    z-index: 10;
                    transition: 0.3s ease;
                    &.hidden{
                        opacity: 0;
                        visibility: hidden;
                    }
                    /*マイホームできたカモボタン*/
                    .myhome_btn_sp {
                        margin: -39px 10px 0 auto;

                        img {
                            height: 84px;
                        }
                    }

                    #kamo_fukidashi {
                        display: none;
                        position: absolute;
                        top: -150px;
                        right: 45px;
                    }
                }
            }

            .masonry {
                margin: 0;
            }

            /*すきカモリスト*/
            .my_page_main {
                max-width: 100%;
                margin-bottom: 80px;
                /*タイトル*/
                h2 {
                    margin: 76px auto 0;
                    img {
                        padding: 16px 0 12px;
                    }
                }

                /*選択フォルダ名*/
                h3 {
                    margin: 0 auto -40px;
                }

                /*ホームボタン*/
                .homebtn {
                    position: absolute;
                    top: -50px;
                    left: -195px;
                }
            }
            .back_btn {
                width: 10px;
                top: 155px;
                left: 10px;
                z-index: 10;
            }
        }
    }
</style>
